// Brand exposure traffic-light colors. Used by the Assessment trajectory
// chips on the Dashboard and the Quiz history list.
// Red / orange / green semantically signals "how concerned should I be" —
// HIGH = red (act now), MEDIUM = orange (watch closely), LOW = green (you're good).
// PRE_LAUNCH stays navy because it's not on the risk gradient — it's a different state.

export const EXPOSURE_META = {
  high:       { label: "HIGH",       color: "#b91c1c" }, // red
  medium:     { label: "MEDIUM",     color: "#ea580c" }, // orange
  low:        { label: "LOW",        color: "var(--evergreen)" }, // green
  pre_launch: { label: "PRE-LAUNCH", color: "var(--navy)" },
};

export const exposureMetaFor = (level) =>
  EXPOSURE_META[level] || EXPOSURE_META.medium;

export const fmtDate = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString(undefined, {
      month: "short",
      day: "numeric",
      year: "numeric",
    });
  } catch {
    return iso;
  }
};
